import styled from "styled-components";

const LinkText = styled.a`
  color: ${props =>
    props.externalLink ? props.theme.salmon : props.theme.white};
`;

export default LinkText;
